import { HeatmapAggregate } from './../../_models/heatmap-aggregate';
import { Component, Inject, Renderer2, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { SelectItem } from 'primeng/primeng';

import { HttpErrorHandler } from '../../shared/http-error-handler';

import { Specie } from '../../_models/specie';
import { SpecieService } from '../../_services/specie.service';
import { HeatmapCapturesService } from '../../_services/heatmap-captures.service';

import { NotificationsService } from '../../_services/notifications.service';
import { Profile } from '../../_models/profile';
import { HeatmapAggregateFilter } from '../../_models/heatmap-aggregate';
import { ColorMapper } from 'app/shared/color-mapper';
import { Ship } from 'app/_models/ship';
import { ShipService } from 'app/_services/ship.service';
import { Filter } from 'app/shared/filter';

@Component({
  selector: 'app-heatmap-discards',
  templateUrl: './heatmap_discards.component.html',
  styleUrls: ['./_heatmap_discards.component.scss'],
})
export class HeatmapDiscardsComponent extends Filter implements OnInit {
  filterParams: any[];
  public currentYear = new Date().getFullYear();
  public profile: Profile;
  errorMessage: string;
  filter: HeatmapAggregateFilter = new HeatmapAggregateFilter();
  htmlText: string;

  form: FormGroup;

  species: SelectItem[] = [];
  selectedSpecies: Specie[];
  ships: SelectItem[] = [];
  selectedShips: Ship[];

  startDate: Date;
  endDate: Date;
  heatmapAggregate: any = [];
  max_value = 0;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private heatmapCapturesService: HeatmapCapturesService,
    private renderer: Renderer2,
    private router: Router,
    route: ActivatedRoute,
    protected notificationsService: NotificationsService,
    private specieService: SpecieService,
    private shipService: ShipService,
    protected httpErrorHandler: HttpErrorHandler,

    @Inject(DOCUMENT) private document: Document,
    private renderer2: Renderer2
  ) {
    super();
    this.form = fb.group({
      specie: [''],
      start_date: [''],
      end_date: [''],
    });
  }

  ngOnInit() {
    this.filter = new HeatmapAggregateFilter(this.filterParams);

    if (this.filter.start_date) {
      this.startDate = new Date(this.filter.start_date);
    }

    if (this.filter.end_date) {
      this.endDate = new Date(this.filter.end_date);
    }

    this.profile = Profile.apiMap(JSON.parse(localStorage.getItem('profile')));
    this.getSpecies();
    this.getShips();
    this.initMap();
  }

  getSpecies() {
    this.specieService.get_species_association().subscribe(
      (response) => {
        this.species = this.parseDropdownResults(response, new Specie(), '_label', false);
        this.selectedSpecies = this.selectMultipleDropdownItems(response, this.filter.specie);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
  getShips() {
    this.shipService.list(1, 10000, '', '').subscribe(
      (response) => {
        this.ships = this.parseDropdownResults(response.results, new Ship(), 'name', false);
        this.selectedShips = this.selectMultipleDropdownItems(response.results, this.filter.ship);
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }
  getStatisticalsRect() {
    this.heatmapCapturesService.list(1, 7000, '', '').subscribe(
      (response) => {
        this.heatmapAggregate = response.results;
        this.initMap();
      },
      (error) => this.httpErrorHandler.handleHttpError(error)
    );
  }

  initMap() {
    const coord = {
      lat: 36.473208,
      lng: -9.729552,
    };
    const map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
      zoom: 4,
      center: coord,
      mapTypeId: 'roadmap',
      streetViewControl: false,
      mapTypeControl: false,
      gestureHandling: 'greedy',
      styles: [
        {
          featureType: 'administrative.neighborhood',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [{ visibility: 'off' }],
        },
        {},
      ],
    });

    ColorMapper.assignment(this.heatmapAggregate);

    this.heatmapAggregate.forEach((zone) => {
      const coord_polygon = [];

      if (zone.polygon !== '') {
        const coord_array = zone.polygon.split(',');
        let last_coord = {};
        for (const my_coord of coord_array) {
          const coordinates = my_coord.split(' ');
          if (coordinates[0] !== '') {
            last_coord = { lat: parseFloat(coordinates[0]), lng: parseFloat(coordinates[1]) };
            coord_polygon.push(last_coord);
          }
        }

        // Construct the polygon.
        const polygon = new google.maps.Polygon({
          paths: coord_polygon,
          strokeColor: zone.color,
          strokeOpacity: 0,
          strokeWeight: 0,
          fillColor: zone.color,
          fillOpacity: zone.opacity,
        });

        const contentString =
          '<div id="content"><h6 class="text-center">Zona: ' +
          zone.name +
          '</h6><div id="bodyContent">Total Descartes: ' +
          zone.discards +
          ' kg</div></div>';

        const infowindow = new google.maps.InfoWindow({
          content: contentString,
        });

        let prev_infowindow = null;

        polygon.setMap(map);

        google.maps.event.addListener(polygon, 'click', function (event) {
          if (prev_infowindow) {
            prev_infowindow.close();
          }
          prev_infowindow = infowindow;
          infowindow.setPosition(new google.maps.LatLng(last_coord['lat'], last_coord['lng']));
          infowindow.open(map, polygon);
        });

        google.maps.event.addListener(map, 'click', function (event) {
          infowindow.close();
        });
      }
    });
  }

  validateForm() {
    this.errorMessage = '';
    this.filter.specie = [];
    if (this.selectedSpecies) {
      this.filter.specie = this.selectedSpecies;
    } else {
      this.errorMessage = 'Debe seleccionar una especie';
    }
    if (this.selectedShips) {
      this.filter.ship = this.selectedShips;
    }

    if (this.startDate) {
      this.startDate.setHours(23);
      this.filter.start_date = this.startDate.toISOString().substring(0, 10);
    } else {
      this.errorMessage = 'Debe seleccionar fecha de inicio y fin';
    }

    if (this.endDate) {
      this.endDate.setHours(23);
      this.filter.end_date = this.endDate.toISOString().substring(0, 10);
    } else {
      this.errorMessage = 'Debe seleccionar fecha de inicio y fin';
    }
    if (this.errorMessage === '') {
      const diff_dates = this.endDate.getTime() - this.startDate.getTime();
      const days = diff_dates / (1000 * 3600 * 24);
      if (days > 365 || days < 0) {
        this.errorMessage = 'Debe seleccionar máximo 12 meses';
      }
    }
  }

  onSubmit(event) {
    event.preventDefault();
    this.filter.reset();
    this.validateForm();
    if (this.errorMessage === '') {
      if (!this.loading) {
        this.loading = true;
        this.max_value = 0;

        let params = HeatmapAggregateFilter.serializeRouterParams(this.filter);
        params = this.filter.serializeQueryParams(params);
        this.heatmapCapturesService.get_heatmap_discards(params).subscribe(
          (response) => {
            this.loading = false;
            this.heatmapAggregate = response;
            this.max_value = Math.max.apply(
              Math,
              this.heatmapAggregate.map(function (o) {
                return o.captures;
              })
            );
            this.initMap();
          },
          (error) => this.httpErrorHandler.handleHttpError(error)
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/maps/heatmaps_discards/heatmap_discards.component.ts